import { render } from "./CreateIntent.vue?vue&type=template&id=36652dd4&scoped=true"
import script from "./CreateIntent.vue?vue&type=script&lang=js"
export * from "./CreateIntent.vue?vue&type=script&lang=js"

import "./CreateIntent.vue?vue&type=style&index=0&id=36652dd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36652dd4"]])

export default __exports__